export const CurrencyTypeEnum = {
    USD: 'USD',
    EUR: 'EUR',
    RUB: 'RUB',
}